import { Box, Stack } from "@mui/material";
import React, { memo } from "react";
import { Dashboard } from "../../../../../types/files";
import DashboardSelect from "../../../dashboards/DashboardSelect";

const SelectionCell: React.FC<{
    dashboard: Dashboard,
    collectionKey?: string,
}> = ({ dashboard, collectionKey }) => {
    return (<>
        <Stack alignItems="center" justifyContent="center" width="100%">
            {!!collectionKey ? (
                <DashboardSelect collection={collectionKey} dashboard={dashboard} />
            ) : (<Box width={40} />)}
        </Stack>
    </>);
}

export default memo(SelectionCell);
